module.exports = __webpack_public_path__ + "static/img/xinBtn.72b63c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Btn/xinBtn.png
// module id = TiJP
// module chunks = 0